import CheckboxSelectionProcessor from '../../Components/Core/Processors/CheckboxSelectionProcessor'
import MultiLegSelectionResultProcessor from '../../Components/Core/SelectionResults/MultiLegSelectionResultProcessor'
import MultiLegValidator from '../../Validation/MultiLegValidator'
import BetTypeInformation from '../Betting/BetTypeInformation'
import type { IConfigureBetType } from './IConfigureBetType'

export default class QuaddieConfigurator implements IConfigureBetType {
  build(): BetTypeInformation {
    return new BetTypeInformation({
      betType: 'Quaddie',
      name: 'Quaddie',
      supportsFlexi: true,
      sortOptions: ['Number', 'FixedPrice', 'Price'],
      template: 'multi-leg-template',
      betSelectionTemplate: 'dual-checkbox-selection-template',
      multiBet: true,
      multiSelections: true,
      processor: new CheckboxSelectionProcessor(1),
      validator: new MultiLegValidator(4),
      selectionResultProcessor: new MultiLegSelectionResultProcessor(),
      checkBoxCount: 1,
      fieldCheckBoxCount: 4,
      sameAsCheckBoxCount: 0,
      legs: 4,
    })
  }
}
